export const LOCALES = {
  en: "en",
  es: "es",
  fr: "fr",
} as const;

export type Locale = (typeof LOCALES)[keyof typeof LOCALES];

export const LOCALE_NAMES: Record<Locale, string> = {
  en: "English",
  es: "Español",
  fr: "Français",
};

export const ALL_LOCALES = Object.values(LOCALES);

export const DEFAULT_LOCALE: Locale = LOCALES.en;
